import { fetchPost, fetchPut, fetchGet, fetchDelete } from '@/utils/request'

export function getFormChannels (query) {
    return fetchGet('/gateway/v1/form-channels', query)
}

export function editFormChannelsStatus (id, query) {
    return fetchPut('/gateway/v1/form-channels/' + id + '/status', query)
}
export function editFormChannels (id, query) {
    return fetchPut('/gateway/v1/form-channels/' + id, query)
}
export function addFormChannels (query) {
    return fetchPost('/gateway/v1/form-channels', query)
}

export function getFeedbacks (query) {
    return fetchGet('/gateway/v1/feedbacks', query)
}

export function deleteFeedbacks (id,query) {
    return fetchDelete('/gateway/v1/feedbacks/' + id, query)
}

export function getSources (query) {
    return fetchGet('/gateway/v1/source', query)
}

export function getTerminals (query) {
    return fetchGet('/gateway/v1/terminals', query)
}

export function getCustomers (query) {
    return fetchGet('/gateway/v1/customers', query)
}

//购房数据统计
export function getCustomerSite (query) {
    return fetchGet('/gateway/v1/customer-statistic/site', query)
}
export function getCustomerDate (query) {
    return fetchGet('/gateway/v1/customer-statistic/date', query)
}
export function getCustomerTerminal (query) {
    return fetchGet('/gateway/v1/customer-statistic/terminal', query)
}
export function getCustomerHouse (query) {
    return fetchGet('/gateway/v1/customer-statistic/house', query)
}
export function getTerminalsNew () {
    return fetchGet('/gateway/v1/get-all-terminal-list')
}

export function getPositionInfo (id,query) { //报名入口
    return fetchGet('/gateway/v1/get-sign-up-info/'+id,query)
}
export function getCustomerForm (query) { //表单报名入口
    return fetchGet('/gateway/v1/customer/sign-up-statistic', query)
}
export function getCustomerIM (query) { //IM报名入口
    return fetchGet('/gateway/v1/customer/sign-up-statistic', query)
}

export function searchAgentList (query) { //IM经纪人模糊查询
    return fetchGet('/gateway/v1/house-im-seat/auto-complete-brokers', query)
}
export function getImList (query) { //IM聊天记录
    return fetchGet('/gateway/v1/im/conversation-list', query)
}
export function getImDetail (query) { //IM聊天记录详情
    return fetchGet('/gateway/v1/im/conversation-msg-list', query)
}
export function getImAnalysis (query) { //IM聊天统计
    return fetchGet('/gateway/v1/im/consult-statistic-list', query)
}
//房贷计算器
export function getCalputers (query) {
    return fetchGet('/gateway/v1/lending_rates/list', query)
}
export function setCalputer (query) {
    return fetchPost('/gateway/v1/lending_rates', query)
}
export function getFilterWords () { //获取违禁词词库
    return fetchGet('/gateway/v1/filter/words')
}